const $inject = ['$q', '$http'];

const lbaLeafletMapServiceService = function ($q, $http) {
  var service = {};

  service.getPosByAddress = function get(query) {
    let deferred = $q.defer();

    query = encodeURIComponent(query);
    console.log('lbaLeafletMapService.js - Query:', query);
    
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${query}`;
    
    $http.get(url)
      .success((data) => {
        const mappedData = {
          resourceSets: [{
            resources: []
          }]
        };

        if (data && data.length > 0) {
          mappedData.resourceSets[0].resources = data.map(item => {
            const lat = parseFloat(item.lat);
            const lon = parseFloat(item.lon);
            
            return {
              // Keep original structure for compatibility
              point: {
                coordinates: [lat, lon]
              },
              geocodePoints: [{
                coordinates: [lat, lon]
              }],
              name: item.display_name,
              address: {
                formattedAddress: item.display_name
              }
            };
          });
        }
        
        deferred.resolve(mappedData);
      })
      .error((error) => {
        deferred.resolve({
          resourceSets: [{
            resources: []
          }]
        });
      });

    return deferred.promise;
  };

  return service;
};

lbaLeafletMapServiceService.$inject = $inject;

export default lbaLeafletMapServiceService;


// WEBPACK FOOTER //
// ./src/services/lbaLeafletMapService.js